import { createSlice } from "@reduxjs/toolkit";
import { 
    fetchUserThreadChats,
    fetchUserThreads,
    fetchUserThreadSystemNotifications
}  from "../thunks/threadThunk";
import {
    fetchUserOrderByRoomId
} from "../thunks/orderThunk";

const threadSlice = createSlice({
    name: "thread",

    initialState: {
        threads: [],
        selectedThreadNotifications: [],
        selectedThreadChat: [],
        selectedPage: null,
        selectedChatsPage: null,
        //...
        selectedThreadId: null,
        selectedThreadRoomId: null,
        selectedFormType: "message",
        selectedThread: null,
        selectedOrder: null
    },

    reducers: {
        clearThreads: (state) => {
            state.threads = [];
            state.selectedThreadChat = [];
            state.selectedThreadNotifications = [];
        },

        clearThreadChats: (state) => {
            state.selectedThreadChat = [];
        },

        clearSelectedThreadAndOrder: (state) => {
            state.selectedOrder = null;
            state.selectedThread = null;
        },

        clearSelectedThreadRoomIdAndThreadId: (state) => {
            state.selectedThread = null;
            state.selectedOrder = null;
            state.selectedThreadRoomId = null;
            state.selectedThreadId = null;
            state.selectedPage = null;
            state.selectedChatsPage = null;
            state.selectedFormType = "message";
            state.threads = [];
            state.selectedThreadNotifications = [];
            state.selectedThreadChat = [];
        },

        setThreads: (state, action) => {
            state.threads = [...state.threads, ...action.payload];
        },

        setBulkThreads: (state, action) => {
            state.threads = action.payload;
        },

        setThreadChats: (state, action) => {
            state.selectedThreadChat = [...state.selectedThreadChat, ...action.payload];
        },

        setThreadBulkChats: (state, action) => {
            state.selectedThreadChat = action.payload;
        },

        updateThreadMessage: (state, action) => {
            const { messageId, threadId, content } = action.payload || {};

            state.selectedThreadChat = state.selectedThreadChat.map((message) => (
                message?._id?.toString() === messageId?.toString()
                    ? { ...message, content }
                    : message
            ));

            state.threads = state.threads.map((thread) => {
                const isLastMessage = thread?.lastMessage?._id?.toString() === messageId?.toString();

                if (isLastMessage || (thread?._id?.toString() === threadId?.toString() && isLastMessage)) {
                    return {
                        ...thread,
                        lastMessage: {
                            ...thread.lastMessage,
                            content,
                        },
                    };
                }

                return thread;
            });
        },

        removeThreadMessage: (state, action) => {
            const { messageId, threadId, lastMessage } = action.payload || {};
            state.selectedThreadChat = state.selectedThreadChat.filter(
                (message) => message?._id?.toString() !== messageId?.toString()
            );
            state.threads = state.threads.map((item) => (
                item?._id?.toString() === threadId?.toString()
                    ? { ...item, lastMessage: lastMessage || null }
                    : item
            ));
            if(state.selectedThread?._id?.toString() === threadId?.toString()){
                state.selectedThread = { ...state.selectedThread, lastMessage: lastMessage || null };
            }
        },

        setSelectedPage: (state, action) => {
            state.selectedPage = action.payload;
        },

        setSelectedChatsPage: (state, action) => {
            state.selectedChatsPage = action.payload;
        },

        setSelectedThreadId: (state, action) => {
            state.selectedThreadId = action.payload;
        },
        
        setSelectedThreadRoomId: (state, action) => {
            state.selectedThreadRoomId = action.payload;
        },

        setSelectedFormType: (state, action) => {
            state.selectedFormType = action.payload;
        },

        setSelectedThread: (state, action) => {                        
            state.selectedThread = action.payload;
        },

        setSelectedOrder: (state, action) => {
            state.selectedOrder = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            // fetch all user threads
            .addCase(fetchUserThreads.fulfilled, (state, action) => {
                state.threads = [...state.threads, ...action.payload.data.threads] || [];
            })

            // fetch  user thread chats
            .addCase(fetchUserThreadChats.fulfilled, (state, action) => {
                // console.log(action.payload.data.chats);
                // state.selectedThreadChat = [...state.selectedThreadChat, ...action.payload.data.chats] || [];
                state.selectedThreadChat = action.payload.data.chats;
            })

            // fetch  user thread sysem notifications
            .addCase(fetchUserThreadSystemNotifications.fulfilled, (state, action) => {
                // console.log(action.payload?.data);
                state.selectedThreadNotifications = action.payload?.data || [];
            })

            // fetch the user order by given room id
            .addCase(fetchUserOrderByRoomId.fulfilled, (state, action) => {
                // console.log(action.payload?.data);
                state.selectedOrder = action.payload.data;
            })
    },
});

export const { 
    clearThreads, 
    clearThreadChats,
    clearSelectedThreadAndOrder,
    clearSelectedThreadRoomIdAndThreadId,
    setThreads,
    setBulkThreads,
    setThreadChats,
    setThreadBulkChats,
    updateThreadMessage,
    removeThreadMessage,
    setSelectedPage,
    setSelectedChatsPage,
    setSelectedThreadId, 
    setSelectedThreadRoomId, 
    setSelectedFormType,
    setSelectedThread,
    setSelectedOrder 
} = threadSlice.actions;
export default threadSlice.reducer;
